// Utility-specific landing pages. These target searches homeowners actually make
// ("Solar BGE Maryland", "Pepco net metering"). Copy is adapted from Gabe's own
// words — he answers these questions every day. Add a utility here and it gets a
// route, a nav/footer link surface, and a rendered page automatically.

export const utilities = [
	{
		id: 'bge',
		name: 'BGE',
		fullName: 'Baltimore Gas & Electric',
		label: 'Solar With BGE',
		region: 'Maryland',
		summary:
			'BGE is one of the largest electric utilities in Maryland, and many of my clients receive service through BGE. Solar can lower your monthly bill and protect you from future BGE rate increases.',
		intro: [
			'BGE is one of the largest electric utilities in Maryland, and many of my clients receive service through BGE.',
			"If you're a BGE customer, solar can help reduce your monthly electric bills while protecting you from future utility rate increases.",
		],
		netMetering: [
			'When your solar system produces more electricity than your home is using, the excess energy is sent back to the grid.',
			"BGE provides credits for that excess production through Maryland's net metering program.",
			'These credits can offset electricity you use at night or during lower-production periods.',
		],
		afterInstall: [
			'County inspection is performed',
			'Paperwork is submitted to BGE',
			'BGE schedules a meter swap',
			'Permission to Operate (PTO) is issued',
			'Your system is activated',
		],
		afterInstallNote:
			'The process is straightforward, and I help manage every step.',
	},
	{
		id: 'pepco',
		name: 'Pepco',
		fullName: 'Pepco',
		label: 'Solar With Pepco',
		region: 'Maryland & Washington DC',
		summary:
			"Pepco customers across Maryland and DC can take advantage of solar and Maryland's net metering program. Many have seen large rate increases over the past few years — solar lets you produce your own power instead.",
		intro: [
			"Pepco customers throughout Maryland and Washington DC can take advantage of solar energy and Maryland's net metering program.",
			'Many Pepco customers have experienced significant rate increases over the past several years. Solar allows homeowners to produce their own power and reduce dependence on utility rate increases.',
		],
		netMetering: [
			'When your panels produce more than your home is using, the surplus flows back to the grid and earns net-metering credits.',
			'Those credits offset the power you pull from Pepco at night and during lower-production months — lowering your overall bill.',
		],
		// Pepco copy frames it as the full project lifecycle rather than just post-install.
		afterInstall: [
			'Site assessment',
			'Engineering review',
			'Utility application',
			'County permitting',
			'Installation',
			'Inspection',
			'Permission to Operate (PTO)',
		],
		afterInstallNote:
			'I personally guide clients through each phase and provide updates throughout the process.',
		afterInstallTitle: 'What to expect',
	},
	{
		id: 'potomac-edison',
		name: 'Potomac Edison',
		fullName: 'Potomac Edison (FirstEnergy)',
		label: 'Solar With Potomac Edison',
		region: 'Western & Central Maryland',
		summary:
			'Potomac Edison serves much of western and central Maryland. Solar pairs with Maryland net metering to cut your bill and hedge against rising utility rates.',
		intro: [
			'Potomac Edison serves a large part of western and central Maryland, and I work with these customers regularly.',
			"As a Potomac Edison customer, going solar lets you generate your own electricity and lean on Maryland's net-metering program to credit what you send back to the grid.",
		],
		netMetering: [
			'Excess solar production is exported to the grid and credited to your account under Maryland net metering.',
			'You draw those credits back down at night and in lower-production months, so more of your annual usage is covered by your own panels.',
		],
		afterInstall: [
			'County inspection is performed',
			'Interconnection paperwork is submitted to Potomac Edison',
			'A meter swap is scheduled',
			'Permission to Operate (PTO) is issued',
			'Your system is activated',
		],
		afterInstallNote: 'I manage the utility coordination from start to finish.',
	},
	{
		id: 'delmarva',
		name: 'Delmarva Power',
		fullName: 'Delmarva Power',
		label: 'Solar With Delmarva Power',
		region: 'Eastern Shore of Maryland',
		summary:
			"Delmarva Power serves Maryland's Eastern Shore. Solar plus Maryland net metering helps Delmarva customers offset their usage and protect against rate hikes.",
		intro: [
			"Delmarva Power serves Maryland's Eastern Shore, and Eastern Shore homeowners are great candidates for solar.",
			"Going solar as a Delmarva customer lets you produce your own power and use Maryland's net-metering program to credit the surplus you send to the grid.",
		],
		netMetering: [
			'When your system overproduces, the extra energy is exported to Delmarva and credited to your account.',
			'Those credits offset what you pull from the grid later — trimming your overall electric cost across the year.',
		],
		afterInstall: [
			'County inspection is performed',
			'Interconnection paperwork is submitted to Delmarva Power',
			'A meter swap is scheduled',
			'Permission to Operate (PTO) is issued',
			'Your system is activated',
		],
		afterInstallNote:
			'I handle the Delmarva paperwork and keep you updated through PTO.',
	},
];

export function getUtility(id) {
	return utilities.find((u) => u.id === id);
}
